import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
    name: "PrintPartImages",

    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId"]),
    },
    props: {
        partImageUrls: Array,
        closeForm: {
            type: Function,
            required: true,
        },
    },

    data: () => ({
        loadedImageCount: 0
    }),
    watch: {
        "loadedImageCount": function() {
            if(this.loadedImageCount == this.partImageUrls.length){
                window.print();
                this.closeForm();
            }
        }
    }
});
